module.exports = __webpack_public_path__ + "img/SK.6a7a6c61.png";